import { getOpenId, setOpenId } from '@/utils/auth'
import { getWorkbenchClientDetail ,getClientDetail } from '@/api/client'




const state = {
  hasErr: false,
  errMsg: '',
  openId: getOpenId(),
  currDate: null,
  currYm: null,
  currClient: null,
  currClientDetail: null,
  clientList: [],
  workbenchInfo:[],
  loading:false,
  balanceData:[]
}

const mutations = {
  SET_LOADING_STATUS: (state,data) => {
    state.loading = data
  },
  SET_ERR_MSG: (state, { hasErr, errMsg }) => {
    state.hasErr = hasErr
    state.errMsg = errMsg
  },
  SET_OPEN_ID: (state, openId) => {
    state.openId = openId
  },
  SET_CURR_DATE: (state, currDate) => {
    state.currDate = currDate
  },
  SET_CURR_YM: (state, currYm) => {
    state.currYm = currYm
  },
  SET_CURR_CLIENT: (state, currClient) => {
    state.currClient = currClient
  },
  SET_CLIENT_LIST: (state, clientList) => {
    state.clientList = []
    if (clientList && clientList.length > 0) {
      clientList.forEach(client => {
        client.name = client.client_name
        client.subname = client.client_sname
        state.clientList.push(client)
      })
    }
  },
SET_WORKBENCH_INFO:(state, data) => {
  state.workbenchInfo = data
},
SET_CURR_CLIENT_DETAIL: (state, detail) => {
  state.currClientDetail = detail
},
SET_BALANCE_DATA: (state, data) => {
  state.balanceData = data
}
}

const actions = {
  error({ commit }, errObj) {
    commit('SET_ERR_MSG', errObj)
  },
  setOpenId({ commit }, openId) {
    setOpenId(openId)
    commit('SET_OPEN_ID', openId)
  },
  setCurrentDate({ commit }, currDate) {
    commit('SET_CURR_DATE', currDate)
    commit('SET_CURR_YM', String(currDate).substring(0, 7))
  },
  async setCurrentClient({ commit }, client) {
    commit('SET_CURR_CLIENT', client)
    // const data = await getWorkbenchClientDetail({ client_id: client.id })
    // commit('SET_WORKBENCH_INFO', client)
    const data = await getClientDetail({ client_id: client.id ,dept_id:client.dept_id })
    commit('SET_CURR_CLIENT_DETAIL', data.obj)
    commit('SET_CURR_DATE', data.obj.curr_date)
    commit('SET_CURR_YM', String(data.obj.curr_date).substring(0, 7))
    
  },
  setClientList({ commit }, clientList) {
    commit('SET_CLIENT_LIST', clientList)
  },
  // setBalanceData({ commit }, currDate) {
  //   const data = await getClientDetail({ client_id: client.id ,dept_id:client.dept_id })
  //   commit('SET_BALANCE_DATA', currDate)
  // },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js